import axios from 'axios';
import {showAlert} from './alerts';

export const forgotPassword = async (email) => {
    try {
        const {data} = await axios.post('/api/v1/users/forgotPassword', {email});
        if(data.status === 'success'){
            showAlert('success', data.message);
            setTimeout(() => {
                window.location.assign('/login')
            }, 5000)
        }
    } catch (error) {
        showAlert('error', error.response.data.message)
    }
}